import axios from "axios";

class ExecuteAxios {
    constructor() {
        this.axiosInstance = axios.create();

        this.axiosInstance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    window.location.href = "/login";
                }
                return Promise.reject(error);
            }
        );
    }

    static async api(type, route, parameters = null, responseUser) {
        try {
            const response = await new ExecuteAxios().axiosInstance[type]('/api/perichert' + route, parameters);
            if (!responseUser) {
                return response.data;
            }
            switch (type) {
                case 'delete':
                    if (response.data === 'BAD_REQUEST') {
                        alert("Erro ao excluir registro.");
                        return false;
                    }
                    alert("Registro excluído com sucesso.");
                    return true;
                case 'post':
                    if (response.data === 'BAD_REQUEST') {
                        alert("Erro ao adicionar registro. Verifique os dados informados.");
                        return false;
                    }
                    if (response.data === 'CONFLICT') {
                        alert("Já existe registro para o item selecionado.");
                        return false;
                    }
                    alert("Registro adicionado com sucesso.");
                    return true;
                case 'put':
                    if (response.data === 'BAD_REQUEST') {
                        alert("Erro ao atualizar registro. Verifique os dados informados.");
                        return false;
                    }
                    if (response.data === 'CONFLICT') {
                        alert("Já existe registro para o item selecionado.");
                        return false;
                    }
                    if (response.data === 'ACCEPTED') {
                        alert("Registro atualizado com sucesso.");
                        return true;
                    }
                    return true;
                default:
                    return response.data;
            }
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Erro desconhecido.";

            alert(message);

            if (message == 'O colaborador selecionado já possui uma alocação para o horário informado. Por favor verifique.') {
                return 1;
            }

            return false;
        }
    }
}

export default ExecuteAxios;
